import React, { useEffect } from "react";
import { Link, useParams, useHistory } from "react-router-dom";
import { PageHeader, Button, Card, Row, Col } from "antd";
import { reverse } from "named-urls";
import { useDispatch, useSelector } from "react-redux";
import { useInjectReducer, useInjectSaga } from "redux-injectors";
import { sliceKey, reducer, actions } from "./slice";
import { viewLabSaga } from "./saga";
import * as selectors from "./selectors";
import { addressToStringMultiLine } from "../../../../utils/formatter";
import routes from "../../../../../routes";
import Loader from "../../../../components/Loader";
import { useAuth } from "../../../../contexts/auth";

const AddressCard = ({ title, address, options }) => {
  return (
    <Card
      title={title}
      style={{ width: 300, marginBottom: 30 }}
      //Can be implemented for future options
      /*  <EditOutlined key="edit" onClick={() => setShowForm(true)} />,
        <DeleteOutlined key="delete" />, */
    >
      <div style={{ minHeight: 120 }}>{addressToStringMultiLine(address)}</div>
    </Card>
  );
};

const ViewLabPartner = () => {
   const auth = useAuth();
    const user = auth.loggedInUser;
    const userRole = user.role;
  useInjectReducer({ key: sliceKey, reducer: reducer });
  useInjectSaga({ key: sliceKey, saga: viewLabSaga });
  const dispatch = useDispatch();
  const { labId } = useParams();
  const history = useHistory();

  useEffect(() => {
    dispatch(actions.fetchLabDetails({ id: labId }));
  }, [dispatch, labId]);

  const labData = useSelector(selectors.selectLabDetails) || {};
  console.log(labData);
  const loading = useSelector(selectors.selectLoading);

  const showLoader = loading;
  const handleBack = () => {
    history.push(routes.backOffice.labPartners.list);
  };

  return (
    <div style={{ height: "100%" }}>
      <PageHeader
        ghost={false}
        title="Lab Details"
        onBack={handleBack}
        subTitle={labData.name}
        extra={[
          userRole !== "csc_admin" && (
          <Button key="1" type="primary">
            <Link
              to={reverse(`${routes.backOffice.labPartners.details.edit}`, {
                labId,
              })}
            >
              Edit
            </Link>
          </Button>
  )
        ]}
      />
      {showLoader ? (
        <Loader />
      ) : (
        <div
          style={{
            height: "calc(100vh - 137px)",
            overflowY: "auto",
            padding: 24,
          }}
        >
          <div
            style={{ backgroundColor: "#fff", padding: 20, marginBottom: 30 }}
          >
            <div style={{}}>
              <div
                style={{
                  display: "flex",
                  flex: 1,
                  justifyContent: "space-between",
                }}
              >
                <p>
                  <strong>Lab Name:</strong> {labData.name}
                </p>
                <p>
                  <strong>PoC Name:</strong>
                  {labData.pocName
                    ? labData.pocName
                    : ` ${labData?.poc?.firstName} ${labData?.poc?.lastName} `}
                </p>
                <p>
                  <strong>PoC Contact:</strong>{" "}
                  {labData.pocContact
                    ? labData.pocContact
                    : labData?.poc?.phone}
                </p>
              </div>
              <div>
                <p>
                  <strong>PoC Contact:</strong>
                  {labData.poc ? labData?.poc?.email : "N.A."}
                </p>
              </div>
            </div>
          </div>
          <div style={{ marginBottom: 10 }}>
            <h1>Addresses</h1>
            <Row gutter={32}>
              {labData?.address ? (
                <Col>
                  <AddressCard
                    title="Registered Address"
                    address={labData?.address}
                  />
                </Col>
              ) : (
                ""
              )}
            </Row>
          </div>
        </div>
      )}
    </div>
  );
};

export default ViewLabPartner;
